(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trj-ecoline-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trj-ecoline-film')) {
    customElements.define('trj-ecoline-film', class TrjEcolineFilm extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.control = this.querySelector('[data-film-control]');

        if (!this.videos.length) return;

        this.playLabel = this.dataset.playLabel || 'Riproduci';
        this.pauseLabel = this.dataset.pauseLabel || 'Pausa';
        this.label = this.control?.querySelector('[data-film-control-label]');
        this.mobileViewport = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.updateControl = this.updateControl.bind(this);
        this.activateVideo = this.activateVideo.bind(this);

        if (this.control) {
          this.control.addEventListener('click', () => {
            if (!this.video) return;

            if (this.video.paused) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          });
        }

        this.videos.forEach((video) => {
          video.addEventListener('play', this.updateControl);
          video.addEventListener('pause', this.updateControl);
        });

        if (this.mobileViewport.addEventListener) {
          this.mobileViewport.addEventListener('change', this.activateVideo);
        } else {
          this.mobileViewport.addListener(this.activateVideo);
        }

        this.activateVideo();
      }

      disconnectedCallback() {
        if (!this.mobileViewport) return;

        if (this.mobileViewport.removeEventListener) {
          this.mobileViewport.removeEventListener('change', this.activateVideo);
        } else {
          this.mobileViewport.removeListener(this.activateVideo);
        }
      }

      activateVideo() {
        const desktopVideo = this.querySelector('.trj-ecoline-film__video--desktop');
        const mobileVideo = this.querySelector('.trj-ecoline-film__video--mobile');
        this.video = this.mobileViewport.matches ? (mobileVideo || desktopVideo) : (desktopVideo || mobileVideo);

        this.videos.forEach((video) => {
          if (video !== this.video) {
            video.pause();
            video.preload = 'none';
            return;
          }

          video.preload = 'metadata';

          if (this.reducedMotion.matches) {
            video.pause();
          } else if (this.dataset.autoplay === 'true') {
            video.play().catch(() => {});
          }
        });

        this.updateControl();
      }

      updateControl() {
        if (!this.video || !this.control || !this.label) return;

        const isPaused = this.video.paused;
        const nextAction = isPaused ? this.playLabel : this.pauseLabel;

        this.control.classList.toggle('is-paused', isPaused);
        this.control.setAttribute('aria-label', nextAction);
        this.label.textContent = nextAction;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
